import React, { useEffect, useState } from "react";
import { AxiosError, AxiosResponse } from "axios";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../components/ui/dialog";
import DataTable2 from "shared/DataTable2";
import { Toaster } from "../../components/ui/toaster";
import { useToast } from "../../hooks/use-toast";
import {
  activityErrorsRelation,
  Result,
} from "../../interface/ActivityErrorsRelation";
import { ActivityErrorsRelationAxiosInstance } from "../../Network/ActivityErrorsRelationAxiosInstance";
import { ColumnDef } from "@tanstack/react-table";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/Label";
const ActivityErrorsRelation: React.FC = () => {
  const [items, setItems] = useState<activityErrorsRelation>({ result: [] });
  const [errMsg, seterrMsg] = useState<string>("");
  const [editIndex, setEditIndex] = useState<null | number>(null);
  const [ErrorisValid, setErrorisValid] = useState<boolean>(true);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const token = localStorage.getItem('token') || "";

  useEffect(() => {
    fetchItems();
  }, []);

   // Initialize toast
   const { toast } = useToast();

   const Erroevalidate = (): boolean => {
    if (!errMsg.trim()) {
      setErrorisValid(false); 
      return false;
    }
        setErrorisValid(true);
    return true;
  };
  
  const validateError = (errMsg: string) => {
    if (!errMsg.trim()) {
      setErrorisValid(true);    
    } else {
      setErrorisValid(false);    
    }
  };
  
  const handleError = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    seterrMsg(value);
  // Check as you type
  validateError(value);  
  };


  const clear = () => {
    seterrMsg("");
  };

// Dialog control handlers
const handleAddClick = () => {
  setEditIndex(null);
  clear();
  setIsDialogOpen(true);
};

const handleEditClick = (item: Result) => {
  handleEdit(item);
  setIsDialogOpen(true);
};

const handleEdit =  (item: Result) => {
  seterrMsg(item.err_msg);

  setEditIndex(item.id);
}



  //............................................. get data ...............................................

  const fetchItems = async (): Promise<void> => {
    try {
      const response: AxiosResponse<{ success: boolean; result: Result[] }> =
        await ActivityErrorsRelationAxiosInstance.get("GetALLActivityError");
    
      setItems({ result: [...response.data.result].sort((a: any, b: any) => b.id - a.id) });

      console.log(response.data.result);
    } catch (error) {
      console.error("Error fetching items:", error);
    }
  };
  //............................................. end get data ...............................................
  //............................................. add data ...............................................

  const addItem = async (): Promise<void> => {
    const isFormValid = Erroevalidate();
  
    if (!isFormValid) {
      return;
    }
    try {
      const newerrMsg = { err_msg: errMsg, token: token };
     const response= await ActivityErrorsRelationAxiosInstance.post(
        "addActivityError",
        newerrMsg
      );
      
      if (response.data.success) {
        const result = response.data.result;
  
        if (result && result.success === false && result.error) {
          if (
            result.error ===
            'duplicate key value violates unique constraint "errors_err_msg_key"'
          ) {
            toast({
              title: "Error",
              description: "ErrMsg must be unique",
            });
          } else {
            toast({
              title: "Error",
              description: result.error,
            });
          }
        } else {
          fetchItems();
          clear(); 
          setIsDialogOpen(false);
          setErrorisValid(true); 
          toast({
            title: "Success",
            description: "New Activity Error group Added Successfully.",
          });
        }
      } else {
        toast({
          title: "Error",
          description: "An unexpected error occurred.",
        });
      }
    } catch (error: AxiosError | any) {
      toast({
        title: "Error",
        description:
          error.response?.data?.error || "An unexpected error occurred.",
      });
    }

  };

  //.............................................end add data ...............................................
  //............................................. remove data ...............................................

  const removeItem = async (id: string | number): Promise<void> => {
    try {
      await ActivityErrorsRelationAxiosInstance.delete(
        `deleteActivityError/${id}`, {
    
          data: { token: token },
        }
      );
      console.log(id);
      fetchItems();
    } catch (error) {
      console.error("Error removing item:", error);
    }
  };
  //.............................................end remove data ...............................................
  // ..................................................update data...............................
  const updateItem = async (id: string | number): Promise<void> => {
    try {
      const updatedItem = { err_msg: errMsg, id: id, token: token };

    const response=  await ActivityErrorsRelationAxiosInstance.put(
        `updateActivityError`, updatedItem);

        if (response.data.success) {
          if (response.data.result?.success === false) {
            if (
              response.data.result?.error ===
              'duplicate key value violates unique constraint "errors_err_msg_key"'
            ) {
              toast({
                title: "Error",
                description: "Error message must be unique.",
              });
            } else {
              toast({
                title: "Error",
                description: response.data.result?.error || "An error occurred.",
              });
            }
          } else {
            fetchItems();
            clear();
            setIsDialogOpen(false);
            toast({
              title: "Success",
              description: "Activity Error group updated successfully.",
            });
          }
        }
      } catch (error: AxiosError | any) {
        toast({
          title: "Error",
          description:
            error.response?.data?.error || "An unexpected error occurred.",
        });
      }
  
  };

  //.............................................end update data ...............................................


  const columns: ColumnDef<Result>[] = [
    {
      accessorKey: "id",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          ID
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
    },
    {
      accessorKey: "err_msg",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
 ErrMsg
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
    },
  ];

  return (
    <div className=" container" style={{ margin: "30px" }}>
      {/* title */}
      <h5>
        Activity Errors Relation Screen{" "}
        <span>
          {" "}
          <i className="fa-solid fa-briefcase"></i>{" "}
        </span>{" "}
      </h5>
 
      {/* model */}
      {/* tabIndex="-1" */}
      <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>
              {editIndex === null
                ? "Add Activity Error "
                : "Edit Activity Error"}
            </DialogTitle>
            </DialogHeader>

          <div className="flex flex-col space-y-4">
            <div className="grid gap-2">
              <Label htmlFor="name">ErrMsg</Label>
              <Input
                id="name"
                value={errMsg}
                onChange={handleError}
                placeholder="ErrMsg is Required"
              />
            </div>
             </div>

          <DialogFooter className="gap-2">
            <Button
              onClick={() => {
                if (editIndex === null) {
                  addItem();
                } else {
                  updateItem(editIndex);
                }
              }}

              className="bg-blue-600 hover:bg-blue-700"
            >
              {editIndex === null ? "Add Relation " : "Update Relation "}
            </Button>
            <Button
              variant="outline"
              onClick={() => {
                setIsDialogOpen(false);
                clear();
                
              }}
            >
              Cancel
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
      <Toaster />

      {/* table */}
      <DataTable2
        columns={columns}
        data={items.result}
        searchColumns={["err_msg"]}
        addButtonLabel="Add Activity Error"
        showAddButton={true}
        onEdit={handleEdit}
        onDelete={removeItem}
        onAdd={handleAddClick}
        onEditClick={handleEditClick}
      />
    </div>
  );
};
export default ActivityErrorsRelation;
